import type { DiTypes } from "@iot-platform/core";

export const authenticationTypes = Object.seal({
    repositories: {
        AuthenticationRepository: Symbol.for("AuthenticationRepository"),
        UserSessionRepository: Symbol.for("UserSessionRepository"),
    },
} satisfies DiTypes);
